import * as React from 'react';

import { PropertyFaqsViewModel } from 'src/common/models';

import { PropertyFaqs } from './faq';

export interface DatelessFaqsProps {
  isDateless: boolean;
  propertyFaqs: PropertyFaqsViewModel;
  siteId: number;
  trafficTestBucket: number;
}

export const DatelessFaqs = ({ isDateless, propertyFaqs, siteId, trafficTestBucket }: DatelessFaqsProps) => {
  const isExpediaCom = siteId === 1;
  const isTrafficExperimentEnabled = trafficTestBucket === 1;

  if (!isDateless || !(isExpediaCom || isTrafficExperimentEnabled)) {
    return null;
  }

  return <PropertyFaqs propertyFaqs={propertyFaqs} />;
};
